// eslint-disable-next-line
// eslint-disable-next-line
import { TenderCreationResponse } from '@Types/api/form/tenderRequest/TenderCreationResponse';
import { TenderGetResponse } from '@Types/api/form/tenderRequest/TenderGetResponse';
import { parseDateTime } from '@Utils/transformDateTime';
import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';
import { TenderTableData } from './type';

export const tenderMapper = (
  data: TenderGetResponse & { taskID?: TenderTableData['taskID'] }
): TenderTableData => ({
  key: data.id,
  tenderNo: data.id,
  materialGroup: data.materialGroup || EMPTY_FIELD_PLACEHOLDER,
  classification: data.classification || EMPTY_FIELD_PLACEHOLDER,
  sentOn: parseDateTime(data.tenderSentDate) || EMPTY_FIELD_PLACEHOLDER,
  expiryOn: parseDateTime(data.tenderExpiryDate) || EMPTY_FIELD_PLACEHOLDER,
  tenderFor: data.tenderForDesc || EMPTY_FIELD_PLACEHOLDER,
  prFor: data.prForDesc || EMPTY_FIELD_PLACEHOLDER,
  tenderExtention: data.tenderExtension || EMPTY_FIELD_PLACEHOLDER,
  tenderMode: data.tenderModeDesc || EMPTY_FIELD_PLACEHOLDER,
  priority: data.priority || EMPTY_FIELD_PLACEHOLDER,
  sentCount: data.sentCount != null ? data.sentCount : EMPTY_FIELD_PLACEHOLDER,
  replyCount:
    data.replyCount != null ? data.replyCount : EMPTY_FIELD_PLACEHOLDER,
  approverRecievedOn: parseDateTime(data.createdOn) || EMPTY_FIELD_PLACEHOLDER,
  delayDays: data.delayDays || EMPTY_FIELD_PLACEHOLDER,
  tenderAmonunt: data.tenderAmount || EMPTY_FIELD_PLACEHOLDER,
  status: data.status || EMPTY_FIELD_PLACEHOLDER,
  statusID: data.statusID,
  approver: data.approver || EMPTY_FIELD_PLACEHOLDER,
  action: '',
});

export const tenderDataSourceMap = (
  // eslint-disable-next-line
  data: Array<TenderCreationResponse> | null | undefined
): Array<TenderTableData> => {
  if (data == null) return [];
  return data.map(tenderMapper);
};
